/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLeading } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface AceitarTermoAceiteRequest {
  idTermoAceite: string;
  onSuccess?: () => void;
}

interface State {
  isRequesting: boolean;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  errors: []
};

const aceitarTermoAceiteSlice = createSlice({
  name: "identidade.termoAceite@aceitarTermoAceite",
  initialState,
  reducers: {
    aceitarTermoAceite: (
      state,
      action: PayloadAction<AceitarTermoAceiteRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    aceitarTermoAceiteSuccess: (state): void => {
      state.isRequesting = false;
    },
    aceitarTermoAceiteFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* criar(params: { type: string; payload: AceitarTermoAceiteRequest }) {
  const { onSuccess, idTermoAceite } = params.payload;

  try {
    yield call(
      api.post,
      `api/v1/cidadao/identidade/termo-aceite/${idTermoAceite}`
    );

    onSuccess?.();

    yield put(aceitarTermoAceiteSuccess());
  } catch (error) {
    yield put(aceitarTermoAceiteFailed(formatError(error)));
  }
}

export const {
  aceitarTermoAceite,
  aceitarTermoAceiteSuccess,
  aceitarTermoAceiteFailed
} = aceitarTermoAceiteSlice.actions;

export const { reducer } = aceitarTermoAceiteSlice;

export const saga = takeLeading(aceitarTermoAceite.type, criar);
